import React from 'react'

const ReactToDo = () => {
  return (
    <section className="project">
      <p>This is a ToDo App done with React!</p>
      <iframe title="reactToDo" src="https://react-todo-jopemamo.netlify.app/" />
    </ section>
  )
}

export default ReactToDo;